export default __webpack_public_path__ + "static/media/rajasthan-seal.72857be6.jpg";